import { render } from "./app-layout.vue?vue&type=template&id=f9961daa"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import "./app-layout.vue?vue&type=style&index=0&id=f9961daa&lang=scss"
import "./app-layout.vue?vue&type=style&index=1&id=f9961daa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__